import { memo } from 'react';

import { DateRangeFilter } from '../../../../components/PageFilters/filters/DateRangeFilter';
import type { DateTimeStartEndFilterProps } from './types';

export const auditTrailDateTimeFilterKey = 'audit-trail-date-time-filter';

export const DateTimeStartEndFilter = memo((props: DateTimeStartEndFilterProps) => {
  return <DateRangeFilter {...props} startLabel="Date and time start" endLabel="Date and time end" showTimePickers />;
});
